import NewsMain from "@components/NewsMain";
const News: React.FC = () => {
  return (
    <Container>
      <NewsMain />
    </Container>
  );
};

export default News;
